import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { getRequirementDefinitionTableCellProps } from "../../../../RequirementDefinitions/utils";
import { CustomRequirement } from "../../../types";
import { getPayoutMethodRequirementName } from "../../PayoutMethod/configs/helpers/getPayoutMethodRequirementName";
import { getPayoutMethodRequirementPayerStatusCell } from "../../PayoutMethod/configs/helpers/getPayoutMethodRequirementPayerStatusCell";

export function getPayoutMethodCustomRequirement(
  requirements: IRequirementResponse[]
): CustomRequirement {
  const baseRequirement = requirements[0];

  return {
    payerId: baseRequirement.payerId,
    payerPayeeEngagementIds: baseRequirement.payerPayeeEngagementIds,
    status: baseRequirement.status,
    nameCell: {
      text: getPayoutMethodRequirementName(baseRequirement)
    },
    typeCell: getRequirementDefinitionTableCellProps({
      type: baseRequirement.requirementType
    }),
    clientsCell: {
      text: `${requirements.length} clients`
    },
    engagementsCell: {},
    statusCell: getPayoutMethodRequirementPayerStatusCell(baseRequirement),
    menuActions: []
  };
}
